<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5ZezqJ/tc-custom/9780849922992.jpg?1741121540184" alt="This image is the cover for the book Twirl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Twirl
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Is life making you so dizzy that you’re forgetting what’s most important?</b></p><p>Patsy Clairmont loves a good twirl. The kind that will make a child fall to the ground, squeal with laughter, and then want to get up and spin in circles some more! However, there is a twirl where busy schedules and urgency create a different and unwanted variety of dizzy into our lives.</p><p>Though hurry-up is part of the human dilemma and certain seasons bring more of it than others, if it becomes a lifestyle you might find yourself on the slippery slopes of bitterness, sadness, and depression. Patsy’s hope is to help her readers maintain a dynamic view on life—with activities and choices that lead to renewal and peace. So take a little stroll with Patsy Clairmont through <i>Twirl</i>, and allow her unique perspective and deep well of biblical wisdom to realign your spin on life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patsy Clairmont
      </h2>
      
      <p class="authorDescription body article"><P>Patsy Clairmont is a popular speaker, a coauthor of various Women of Faith devotionals, and the author of such best-selling books as "God Uses Cracked Pots" and "Sportin' a 'Tude." She and her husband live in Brighton, Michigan.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d645d58c